<script setup lang="ts">
const props = defineProps<{
  title?: string;
  titleTop?: boolean;
  withTopSeparator?: boolean;
  withMarginBottom?: boolean;
}>();

const containerClass = computed(() => {
  const containerClass = ["py-1"];

  if (!props.titleTop) {
    containerClass.push("flex");
  }

  if (props.withMarginBottom) {
    containerClass.push("mb-4");
  }

  return containerClass;
});

const titleClass = computed(() => {
  const titleClass = ["!mt-0", "mb-4", "text-gray-900"];

  if (!props.titleTop) {
    titleClass.push("w-1/4");
  }

  return titleClass;
});

const contentClass = computed(() => {
  const contentClass = [];

  if (props.titleTop) {
    contentClass.push("pt-0.5");
  } else {
    contentClass.push("w-3/4");
  }

  return contentClass;
});
</script>

<template>
  <!-- separator -->
  <div v-if="withTopSeparator" class="w-full h-0.5 bg-gray-200 mb-5" />

  <div :class="containerClass">
    <h4 v-if="title" :class="titleClass">
      {{ title }}
    </h4>
    <div :class="contentClass">
      <div class="flex">
        <div v-if="$slots.left || $slots.right" class="w-1/2 space-y-1">
          <slot name="left" />
        </div>
        <div v-if="!$slots.left && !$slots.right && $slots.default">
          <slot name="default" />
        </div>
        <div v-if="$slots.left || $slots.right" class="w-1/2 space-y-1 pl-8">
          <slot name="right" />
        </div>
      </div>
    </div>
  </div>
</template>
